import { withModalProvider } from "../../hoc/withModalProvider";

import { SelectQuestionModal as View, IProps } from "./SelectQuestionModal";

export const SelectQuestionModal = withModalProvider<IProps>(View);
